import React, { memo } from "react"
import { useSelector } from "react-redux"
import UpdateForm from "./participant-form/UpdateForm"
import AddNewForm from "./participant-form/AddNewForm"

const ParticipantForm = memo(() => {
    const { selectedStatus } = useSelector((state) => state.controlPanelSelectedParticipantReducer)

    return <>{selectedStatus ? <UpdateForm /> : <AddNewForm />}</>
})

export default ParticipantForm
